import { MaterielEau } from '../../domain/EAU/materiel-eau';
import { MeasureEau } from '../../domain/EAU/measure-eau';
import { mapper } from '../../tools/mapping/mapper';
import { MeasureEauEntity, MaterielEauEntity } from '../entity';
import type { AppDB } from '../db';

export class MeasureEauRepository {
    constructor(private readonly database: AppDB) {}


    async getMeasureEauEntityByCode(code: string) {
        return await this.database.measureEau.where('Code').equals(code).first(async mee => {
            return mee;
        });
    }

    async getMaterielEauEntityById(id: number) {
        return await this.database.materielEau.where('Id').equals(id).first(async mee => {
            return mee;
        });
    }

    async getMeasureEauByCode(code: string) {
        return await this.database.measureEau.where('Code').equals(code).first(async mee => {
            const me = mapper.map(mee, MeasureEauEntity, MeasureEau);
            if (mee?.MaterielEauId) {
                const mate = await this.database.getMaterielEauEntityById(mee?.MaterielEauId)
                me.MaterielEau = mapper.map(mate, MaterielEauEntity, MaterielEau);
            }
            return me;
        });
    }

    async getMeasureEauById(id: number) {
        return await this.database.measureEau.where('Id').equals(id).first(async mee => {
            const me = mapper.map(mee, MeasureEauEntity, MeasureEau);
            if (mee?.MaterielEauId) {
                me.MaterielEau = mapper.map(await this.database.getMaterielEauEntityById(mee?.MaterielEauId), MaterielEauEntity, MaterielEau);
            }
            return me;
        });
    }

    async attachMeasureEau(measure: MeasureEau, interventionId: number) {
        let eauId: number;
        const mee = mapper.map(measure, MeasureEau, MeasureEauEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);

        eauId = await this.database.measureEau.add(mee);
        await this.database.interventions.update(interventionId, {
            EauIds: ie?.EauIds ? [...ie.EauIds, eauId] : [eauId]
        });

        if (measure.MaterielEau) {
            await this.database.attachMaterielEau(measure.MaterielEau, eauId);
        }
        return eauId;
    }

    async attachMaterielEau(measure: MaterielEau, eauId: number) {
        let materielId: number;
        const mee = mapper.map(measure, MaterielEau, MaterielEauEntity);

        materielId = await this.database.materielEau.add(mee);
        await this.database.measureEau.update(eauId, {
            MaterielEauId: materielId
        });

        return materielId;
    }

    async updateMeasureEau(measure: MeasureEau) {
        const mle = await this.database.getMeasureEauEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return false;
        }
        mapper.mutate(measure, mle, MeasureEau, MeasureEauEntity);
        await this.database.measureEau.update(mle.Id, mle);

        if (measure.MaterielEau && mle.MaterielEauId) {
            const mee = await this.database.getMaterielEauEntityById(mle.MaterielEauId);
            if (mee && mee.Id) {
                mapper.mutate(measure.MaterielEau, mee, MaterielEau, MaterielEauEntity);
                await this.database.materielEau.update(mee.Id, mee);
            }
        }

        return true;
    }

    async cancelMeasureEau(measure: MeasureEau, reason: string) {
        const mee = await this.database.getMeasureEauEntityByCode(measure.Code);
        if (!mee || !mee.Id) {
            return;
        }

        await this.database.measureEau.update(mee.Id, { IsCancelled: true, Observation: reason });
        return true;
    }
}
